export default "__VITE_ASSET__CtuCBMSG__"